import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sUsedRentalsControllerEndpoint = 'UsedRentalsExcel';
const sTransportControllerEndpoint = 'TransportationExcel';


export class UsedRentalsExcelAPI {

  getRUExcelCarsList(ruL1Id = 0) {
    let params = {
      lL1RuId: ruL1Id
    }
    return axios.get(getBackendURL() + sUsedRentalsControllerEndpoint + '/GetCarsListExcel', { params });
  };

  postRUExcelCarsList(formData, ruL1Id, ForceSave) {
    return axios.post(getBackendURL() + sUsedRentalsControllerEndpoint + '/PostCarsListExcel?lL1RuId=' + ruL1Id + '&ForceSave=' + ForceSave, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getRUExcelTransportCarsListByLot(ruL1Id = 0) {
    let params = {
      lL1RuId: ruL1Id
    }
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetLotTransportExcel', { params });
  };

  postRUExcelTransportCarsListByLot(formData, ruL1Id) {
    return axios.post(getBackendURL() + sTransportControllerEndpoint + '/PostTransportExcelByLot?lL1RuId=' + ruL1Id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getRUExcelWRTCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetWaitingTransportExcel');
  };

  getRUExcelWADCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetWaitingArrivalTransportExcel');
  };

  getRUExcelAtDCarsList() {
    return axios.get(getBackendURL() + sTransportControllerEndpoint + '/GetOnDestinyTransportExcel');
  };

  postRUExcelTransportCarsList(formData) {
    return axios.post(getBackendURL() + sTransportControllerEndpoint + '/PostTransportExcel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

}

export default UsedRentalsExcelAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsExcelAPI.js